import React from 'react'
import { Link } from 'react-router-dom'
import { BreadcrumbContent, BreadcrumbCurrent, BreadcrumbLink, BreadcrumbSeparator, ButtonContainer, SelectContainer, ShareButtonGroup, WrapperContainer, WrapperContent, WrapperHeader, WrapperSection, WrapperTitle } from './styled'
import Button from 'components/Form/Button'
import useI18n from 'hooks/useI18n'
import { Icon } from 'ui/styled'
import Select from 'components/Form/Select'
import { shareDayOptions } from 'utils/options'
import { ViewButton, ViewSwitch } from 'screens/AuthenticatedArea/Favorites/styled'
import { GridViewOutlined, HomeOutlined, ViewListOutlined } from '@mui/icons-material'
import { isModularContentType } from 'utils'

export default function Wrapper({ children, listOption, white, data, label, icon, wide, action, nobutton, filter, isActive, setIsActive, cancel, renderOption, setRenderOption, setShareLink, shareLink, noShare, allSelected, selectAll, unselectAll, shareDays, setShareDays }) {

  const { t } = useI18n()
  const allowRenderSwitch = listOption && !data?.supportVideos && !isModularContentType(data?.type)

  return (
    <>
      <WrapperContainer white={white} wide={wide}>
        <WrapperHeader wide={wide}>
          <WrapperContent between center>
            <WrapperSection>
              {data?.section}
            </WrapperSection>
            <BreadcrumbContent>

              {data?.breadcrumbs?.length ? (
                <WrapperTitle aria-label={data.breadcrumbs.map((breadcrumb) => breadcrumb.label).join(' > ')}>
                  {data.breadcrumbs.map((breadcrumb, index) => (
                    <React.Fragment key={`${breadcrumb.label}-${index}`}>
                      {index > 0 ? <BreadcrumbSeparator aria-hidden="true">&gt;</BreadcrumbSeparator> : null}
                      {breadcrumb.to ? (
                        <BreadcrumbLink as={Link} to={breadcrumb.to} $primary={breadcrumb.primary} aria-label={breadcrumb.label}>
                          {breadcrumb.icon === 'home' ? <HomeOutlined aria-hidden="true" fontSize="large" /> : breadcrumb.label}
                        </BreadcrumbLink>
                      ) : (
                        <BreadcrumbCurrent $primary={breadcrumb.primary} aria-label={breadcrumb.label}>
                          {breadcrumb.icon === 'home' ? <HomeOutlined aria-hidden="true" fontSize="large" /> : breadcrumb.label}
                        </BreadcrumbCurrent>
                      )}
                    </React.Fragment>
                  ))}
                </WrapperTitle>
              ) : <WrapperTitle dangerouslySetInnerHTML={{ __html: data?.title }} />}
            </BreadcrumbContent>
          </WrapperContent>
          <ButtonContainer>
            {!shareLink ? null : (
              <SelectContainer>
                <Select
                  id="share-days"
                  placeholder={t('share_link_duration')}
                  options={shareDayOptions}
                  value={`${shareDays || 7}`}
                  onChange={(value) => setShareDays(Number(value))}
                  small
                  secondary
                />
              </SelectContainer>
            )}
            {shareLink || !noShare ? (
              <ShareButtonGroup>
                {!shareLink ? null : (
                  <Button nospace outline color="white" width="fit-content" small onClick={cancel}>
                    Cancel
                  </Button>
                )}

                {noShare ? null :
                  <Button nospace color="blue" width="fit-content" small onClick={setShareLink}>
                    {shareLink ? "Create share" : "Share"}
                    <Icon icon='share' height={'24px'} width={'24px'} />
                  </Button>
                }
                {!shareLink ? null : (
                  <Button nospace color="main" width="fit-content" small onClick={allSelected ? unselectAll : selectAll}>
                    {allSelected ? "Unselect all" : "Select all"}
                  </Button>
                )}
              </ShareButtonGroup>
            ) : null}

            {!allowRenderSwitch ? null :
              // <RenderOptionContent >
              //   <RenderOption left active={renderOption === 'gallery'} onClick={() => setRenderOption('gallery')}>
              //     <Icon icon={renderOption === 'gallery' ? 'gallery-active' : 'gallery'} />
              //   </RenderOption>
              //   <RenderOption active={renderOption === 'list'} onClick={() => setRenderOption('list')}>
              //     <Icon icon={renderOption === 'list' ? 'list-active' : 'list'} />
              //   </RenderOption>
              // </RenderOptionContent>
              <ViewSwitch>
                <ViewButton type="button" active={renderOption === 'gallery'} onClick={() => setRenderOption('gallery')}>
                  <GridViewOutlined fontSize="small" /> {t('favorites_grid')}
                </ViewButton>
                <ViewButton type="button" active={renderOption === 'list'} onClick={() => setRenderOption('list')}>
                  <ViewListOutlined fontSize="small" /> {t('favorites_list')}
                </ViewButton>
              </ViewSwitch>
            }
            {/* {!filter ? null : <Button outline color='primary' width="114px" startIcon={icon} nospace onClick={action}>{t("filter")}</Button>} */}
            {nobutton ? null : <Button nospace outline color='primary' width="114px" startIcon={icon} onClick={action}>{t("see_all")}</Button>}
          </ButtonContainer>
        </WrapperHeader>
        {children}
      </WrapperContainer>
    </>
  )
}
